<template>
  <div>
    <div class="jumbotron">
      <div class="mask"></div>
      <b-row class="mx-auto py-5 text-left" style="max-width: 1460px">
        <b-col sm="12">
          <h1 class="text-white">Privacy</h1>
        </b-col>
      </b-row>
    </div>

    <b-row class="m-2 mx-auto" style="max-width: 1460px">
      <b-col cols="12" class="bg-white text-left my-3">
        <h3>
          ASSOCIAZIONE LANGUAGE AID - ETS INFORMATIVA PER IL TRATTAMENTO DEI DATI PERSONALI ai sensi e per gli effetti
          di cui all’articolo 13, D.Lgs. 30 giugno 2003 n. 196 e art. 13 del Nuovo regolamento Europeo 2016/679 di
          seguito semplificato in “G.D.P.R.”
        </h3>
        <p>
          Ai sensi dell'art. 13 del regolamento (UE) n. 2016/679, recante disposizioni a tutela delle persone e di altri
          soggetti rispetto al trattamento dei dati personali La informiamo che i dati personali, comuni e sensibili, da
          Lei forniti formeranno oggetto di trattamento nel rispetto della normativa sopra richiamata e degli obblighi
          di riservatezza cui è tenuta la nostra associazione. Le forniamo, in coerenza del principio di trasparenza, le
          seguenti informazioni al fine di renderLa consapevole delle caratteristiche e modalità del trattamento dei
          dati di cui l’associazione “LANGUAGE AID - ETS” (in seguito “associazione”) entrerà nella disponibilità ai
          fini dell’adempimento delle proprie finalità.
        </p>

        <h4>Titolare del trattamento</h4>
        <p>
          IL “TITOLARE” DEL TRATTAMENTO, ai sensi dell’articolo 28 del Codice in materia di protezione dei dati
          personali e art. 4 punto 7) del G.D.P.R è l’ASSOCIAZIONE LANGUAGE AID - ETS, via Vittorio Andreis n. 18/16/Z -
          10152 Torino, Codice Fiscale 97857850016, nella persona del legale rappresentante pro-tempore.
        </p>

        <h4>Responsabile del trattamento</h4>
        <p>
          IL “RESPONSABILE DEL TRATTAMENTO” dei dati, della loro comunicazione e conservazione cui è possibile
          rivolgersi per esercitare i diritti di cui all’Art. 12 e/o per eventuali chiarimenti in materia di tutela dati
          personali, è il Sig. MANDARINO Guido, raggiungibile all’indirizzo e-mail: info@languageaid.org
        </p>

        <h4>Luogo di trattamento dei dati</h4>
        <p>
          I trattamenti dei dati connessi ai servizi offerti dall’associazione sono effettuati presso la sede della
          società, Titolare del trattamento e sono curati solo da propri collaboratori, incaricati del trattamento, o da
          eventuali soggetti esterni per operazioni di manutenzione od aggiornamento informatico. Il sito internet è
          ospitato presso un datacenter situato nell’Unione Europea ed eventuali spostamenti presso altre server farm
          avverranno comunque all'interno dell'EU.
        </p>
        <p>Relativamente al sito ed alla piattaforma internet vi segnaliamo inoltre che:</p>
        <ul>
          <li>
            è attivo un modulo che consente di fornire secondo obblighi di legge le informative per privacy e cookies e
            che viene riportata la formula della privacy in ogni pagina del sito;
          </li>
          <li>i dati degli utenti registrati sono accessibili solo a chi è dotato di opportuni privilegi;</li>
          <li>le password non sono mai memorizzate in chiaro;</li>
          <li>Il sito risponde agli standard di sicurezza aggiornati e più diffusi;</li>
          <li>L’accesso all’area riservata del sito avviene in un contesto sicuro (https).</li>
        </ul>

        <h4>Oggetto del trattamento</h4>
        <p>I dati personali oggetto di trattamento sono i seguenti:</p>
        <ul>
          <li>dati personali identificativi (dati anagrafici, indirizzi mail, ecc.)</li>
          <li>dati genetici (dati che rivelano l’origine razziale, etnica, ecc.)</li>
          <li>
            dati biometrici (si tratta dei dati relativi alle caratteristiche fisiche, fisiologiche e/o comportamentali
            desumibili dalla documentazione conservata)
          </li>
          <li>dati sanitari</li>
          <li>le opinioni politiche</li>
          <li>le convinzioni religiose o filosofiche</li>
        </ul>
        <p>Ogni altro dato particolare acquisito in adempimento del mandato conferito.</p>

        <h4>Finalità del trattamento</h4>
        <p>
          I dati di natura personale ed eventualmente sensibili, da Lei forniti o acquisiti da banche dati pubbliche
          saranno oggetto di trattamento per le seguenti finalità, fino a sua opposizione:
        </p>
        <ul>
          <li>svolgimento del servizio da Lei richiesto;</li>
          <li>eventuale richiesta di contatto, con invio di informazioni da Lei richieste;</li>
          <li>inserimento in mailing list;</li>
          <li>perseguimento del legittimo interesse del titolare medesimo.</li>
        </ul>

        <h4>Modalità del trattamento – Conservazione</h4>
        <p>
          Il trattamento sarà svolto in forma automatizzata e manuale, con modalità e strumenti volti a garantire la
          massima sicurezza e riservatezza, ad opera di soggetti di ciò appositamente incaricati in ottemperanza a
          quanto previsto dagli artt. 29 e 32 del G.D.P.R.. Le segnaliamo che, nel rispetto dei principi di liceità,
          limitazione delle finalità e minimizzazione dei dati, ai sensi dell’art. 5 del Regolamento, i Suoi dati
          personali saranno conservati per il periodo di tempo necessario per il conseguimento delle finalità per le
          quali sono raccolti e trattati e per l’ulteriore periodo necessario ad ottemperare agli obblighi normativi. In
          particolare i dati da Lei forniti saranno conservati per il periodo previsto dalla normativa riferita alla
          natura della documentazione.
        </p>

        <h4>Ambito di comunicazione e diffusione</h4>
        <p>
          I Suoi dati, oggetto del trattamento, non saranno diffusi e non saranno oggetto di comunicazione senza Suo
          esplicito consenso, salvo le comunicazioni necessarie che possono comportare il trasferimento di dati ad enti
          pubblici, a consulenti o ad altri soggetti per l’adempimento degli obblighi di legge. I dati conservati su
          server, non saranno trasferiti in Paesi terzi non appartenenti all’Unione Europea.
        </p>

        <h4>Categorie particolari di dati personali</h4>
        <p>
          Ai sensi degli articoli 9 e 10 del G.D.P.R., Lei potrebbe conferire dati qualificabili come “categorie
          particolari di dati personali” e cioè quei dati che rivelano “l'origine razziale o etnica, le opinioni
          politiche, le convinzioni religiose o filosofiche, o l'appartenenza sindacale, nonché dati genetici, dati
          biometrici intesi a identificare in modo univoco una persona fisica, dati relativi alla salute o alla vita
          sessuale o all’orientamento sessuale della persona”. Tali categorie di dati potranno essere trattate solo
          previo Suo consenso.
        </p>

        <h4>Diritti dell’interessato</h4>
        <p>In ogni momento, Lei potrà esercitare, ai sensi degli articoli dal 15 al 22 del G.D.P.R., il diritto di:</p>
        <ol type="A">
          <li>chiedere la conferma dell’esistenza o meno di propri dati personali;</li>
          <li>
            ottenere le indicazioni circa le finalità del trattamento, le categorie dei dati personali, i destinatari o
            le categorie di destinatari a cui i dati personali sono stati o saranno comunicati e, quando possibile, il
            periodo di conservazione;
          </li>
          <li>ottenere l’aggiornamento, la rettifica e la cancellazione dei dati;</li>
          <li>ottenere la limitazione del trattamento;</li>
          <li>
            ottenere la portabilità dei dati, ossia riceverli da un titolare del trattamento, in un formato strutturato,
            di uso comune e leggibile da dispositivo automatico, e trasmetterli ad un altro titolare del trattamento
            senza impedimenti;
          </li>
          <li>
            opporsi al trattamento in qualsiasi momento ed anche nel caso di trattamento per finalità di marketing
            diretto;
          </li>
          <li>
            opporsi ad un processo decisionale automatizzato relativo alle persone ﬁsiche, compresa la profilazione.
          </li>
          <li>
            chiedere al titolare del trattamento l’accesso ai dati personali e la rettifica o la cancellazione degli
            stessi o la limitazione del trattamento che lo riguardano o di opporsi al loro trattamento, oltre al diritto
            alla portabilità dei dati;
          </li>
          <li>
            revocare il consenso in qualsiasi momento senza pregiudicare la liceità del trattamento basata sul consenso
            prestato prima della revoca;
          </li>
          <li>proporre reclamo a un’autorità di controllo.</li>
        </ol>

        <p>
          Lei potrà esercitare i propri diritti con richiesta scritta inviata al titolare del trattamento Associazione
          Language - ETS, all’indirizzo postale della sede legale, contattando il Responsabile del Trattamento al numero
          di telefono Tel +39 011 8390854, oppure inviando una mail all’indirizzo info@languageaid.org
        </p>
        <p>Torino li 20 luglio 2020</p>
      </b-col>
    </b-row>
  </div>
</template>
<script>
export default {
  name: "Privacy",
  data() {
    return {};
  },
  methods: {},
};
</script>
<style scoped>
.jumbotron {
  background-image: url("/img/bg-home.png");
  background-position-y: 80%;
}
</style>
